<div class="submitted-view" appBlockCopyPaste>
    <!-- Animated Background Elements -->
    <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
        <div class="shape shape-5"></div>
    </div>

    <!-- Confetti Container -->
    <div class="confetti-container">
        <div class="confetti" *ngFor="let i of confettiArray; let idx = index" [style.--delay]="idx * 0.1 + 's'"></div>
    </div>

    <div class="success-container">
        <!-- Hero Celebration Section -->
        <div class="hero-section">
            <div class="celebration-circle">
                <div class="pulse-ring"></div>
                <div class="pulse-ring pulse-ring-2"></div>
                <div class="success-icon-wrapper">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                    </svg>
                </div>
            </div>
            <h1 class="hero-title">
                <span class="title-line">🎉 You Did It!</span>
                <span class="title-line">Assessment Submitted</span>
            </h1>
            <p class="hero-message">Your hard work has been recorded. Time to celebrate! 🎊</p>
        </div>

        <!-- Creative Steps Grid -->
        <div class="steps-grid">
            <div class="step-card step-card-1">
                <div class="step-icon-wrapper">
                    <div class="icon-bg"></div>
                    <span class="material-icons">rate_review</span>
                </div>
                <div class="step-content">
                    <h3>Review</h3>
                    <p>We're analyzing your responses</p>
                </div>
                <div class="step-number">01</div>
            </div>

            <div class="step-card step-card-2">
                <div class="step-icon-wrapper">
                    <div class="icon-bg"></div>
                    <span class="material-icons">email</span>
                </div>
                <div class="step-content">
                    <h3>Email</h3>
                    <p>Confirmation on its way</p>
                </div>
                <div class="step-number">02</div>
            </div>

            <div class="step-card step-card-3">
                <div class="step-icon-wrapper">
                    <div class="icon-bg"></div>
                    <span class="material-icons">notifications</span>
                </div>
                <div class="step-content">
                    <h3>Results</h3>
                    <p>We'll notify you soon</p>
                </div>
                <div class="step-number">03</div>
            </div>
        </div>

        <!-- Fun Footer Message -->
        <div class="footer-message">
            <div class="footer-icon">✨</div>
            <p>Feel free to close this window. Everything is saved!</p>
        </div>
    </div>
</div>